"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import s from "underscore.string";
import React from "react";
import "../../api/api";
import classNames from "classnames";
import "../../formatters/general";
import PossibleAdjustments from "./possible_adjustments";
import _ from "underscore";
function onDragStart(e) {
  e.dataTransfer.effectAllowed = "copy";
  e.dataTransfer.setData("text/plain", e.target.value);
}
function invoiceAmount(invoice) {
  var amount = parseFloat(invoice.source_invoice_amount);
  return isNaN(amount) ? 0 : amount;
}
function getDisplayCurrency(props) {
  var _a;
  const loadPayables = props.load.load.tms_carrier_payables;
  if (((_a = props.carrierInvoice) == null ? void 0 : _a.tms_carrier_payable_id) == null || loadPayables.length < 1) {
    return props.load.load.currency;
  } else {
    const matchingPayable = loadPayables.find(
      (x) => x.id === props.carrierInvoice.tms_carrier_payable_id
    );
    return matchingPayable && matchingPayable.currency;
  }
}
function expectedAmountBox(props) {
  var actual = actualTotal(props);
  var sourceAmount = props.sourceInvoiceAmount || 0;
  if (props.carrierInvoice.quickpay_disposition === "applied_to_invoice") {
    var match = parseFloat(String(actual)).toFixed(2) === (parseFloat(String(sourceAmount)) + parseFloat(String(props.quickpayDiscountAmount))).toFixed(2);
  } else {
    var match = parseFloat(String(actual)).toFixed(2) === parseFloat(String(sourceAmount)).toFixed(2);
  }
  if (createdInHubTran(props)) {
    var classes = classNames({});
  } else {
    var classes = classNames({
      "load-detail__info-data-error": !match,
      "load-detail__info-data-match": match
    });
  }
  return /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "text",
      readOnly: true,
      draggable: true,
      onDragStart,
      className: classes,
      value: formattedAmount(props, actual)
    }
  );
}
function createdInHubTran(props) {
  return !_.isEmpty(props.load) && props.load.load.source_system === "hubtran";
}
function formattedAmount(props, amount) {
  if (createdInHubTran(props) || amount === 0) {
    return "-";
  } else {
    return s.numberFormat(Math.abs(parseFloat(amount)), 2);
  }
}
function hasAmountAdjustments(props) {
  return hasOtherInvoiceAdjustments(props) || hasAdjustments(props);
}
function possibleAmountAdjustments(props) {
  if (hasAmountAdjustments(props)) {
    return /* @__PURE__ */ React.createElement(
      PossibleAdjustments,
      {
        forExpectedAmount: true,
        expectedTotal: props.expectedTotal,
        load: props.load,
        carrierInvoice: props.carrierInvoice
      }
    );
  }
}
function actualTotal(props) {
  var adjusted = props.expectedTotal;
  if (hasOtherInvoiceAdjustments(props)) {
    adjusted -= otherInvoicesAdjustment(props);
  }
  if (hasAdjustments(props)) {
    adjusted -= otherAdjustment(props);
  }
  return adjusted <= 0 ? 0 : adjusted;
}
function otherAdjustment(props) {
  if (hasAdjustments(props)) {
    return _.chain(adjustments(props)).pluck("amount").map(parseFloat).reduce((memo, num) => memo + num, 0).value();
  } else {
    return 0;
  }
}
function hasAdjustments(props) {
  return !_.isEmpty(adjustments(props));
}
function adjustments(props) {
  return props.load.load.tms_adjustments;
}
function hasOtherInvoiceAdjustments(props) {
  return isDraftStatus(props) && otherInvoices(props).length > 0;
}
function otherInvoicesAdjustment(props) {
  if (hasOtherInvoiceAdjustments(props)) {
    return _.chain(otherInvoices(props)).map(invoiceAmount).reduce((memo, num) => memo + num, 0).value();
  } else {
    return 0;
  }
}
function isDraftStatus(props) {
  return props.carrierInvoice.state === "draft";
}
function otherInvoices(props) {
  return _.chain(props.load.carrier_invoices).filter((ci) => {
    return ci.id !== props.carrierInvoice.id;
  }).filter(function(ci) {
    return ci.state !== "deleted";
  }).filter(function(ci) {
    return ci.state !== "abandoned";
  }).filter((ci) => {
    return props.use_carrier_charge || ci.carrier_id === props.carrierInvoice.carrier_id;
  }).filter((ci) => {
    return invoiceAmount(ci) !== 0;
  }).value();
}
class InvoiceExpectedAmount extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {});
  }
  render() {
    const currency = getDisplayCurrency(this.props);
    var classes = "small-9 columns";
    var afterAmount = null;
    if (currency) {
      classes = "small-7 columns";
      afterAmount = /* @__PURE__ */ React.createElement("div", { className: "small-2 columns" }, /* @__PURE__ */ React.createElement("span", { className: "postfix" }, currency));
    }
    return /* @__PURE__ */ React.createElement("div", { "data-component": "InvoiceExpectedAmount" }, /* @__PURE__ */ React.createElement("div", { className: "load-detail__invoice-document-info-label" }, /* @__PURE__ */ React.createElement("label", null, "Expected Amount")), /* @__PURE__ */ React.createElement("div", { className: "row collapse" }, /* @__PURE__ */ React.createElement("div", { className: "small-1 columns" }, /* @__PURE__ */ React.createElement("span", { className: "prefix" }, "$")), /* @__PURE__ */ React.createElement("div", { className: classes }, expectedAmountBox(this.props), possibleAmountAdjustments(this.props)), afterAmount));
  }
}
export default InvoiceExpectedAmount;
